module.exports = __webpack_public_path__ + "static/media/notes-wine.81481754.svg";